import { useEffect, useRef } from 'react';
import SectionTitle, {
  SectionTitleProps,
} from 'src/components/ui/SectionTitle';

interface StepTitleProps extends SectionTitleProps {
  step: number;
  totalSteps: number;
}

const StepTitle = ({
  step,
  totalSteps,
  title,
  level = 2,
  className,
  titleClassName,
}: StepTitleProps) => {
  const headingRef = useRef<HTMLHeadingElement>(null);
  const previousStepRef = useRef(step);

  useEffect(() => {
    if (previousStepRef.current === step) return;

    headingRef.current?.focus();
    previousStepRef.current = step;
  }, [step]);

  return (
    <SectionTitle
      headingRef={headingRef}
      title={title}
      level={level}
      tabIndex={-1}
      className={className}
      titleClassName={titleClassName}
    >
      <span className="sr-only" aria-live="polite" aria-atomic="true">
        Step {step} of {totalSteps}
      </span>
    </SectionTitle>
  );
};

export default StepTitle;
